export const VEHICLE_PLATE_LENGTH = 8;
